import { VideoPlaceholder, cn } from "@tosize/ui";
import Image from "next/image";
import type { ComponentProps } from "react";
import type { ImageProps } from "./Context";

interface MediaItemProps extends ComponentProps<"button"> {
	item: ImageProps;
}

export function MediaItem({ item, className, children, ...remainingProps }: MediaItemProps) {
	return (
		<button
			type="button"
			className={cn(
				"group relative aspect-video h-full w-full cursor-zoom-in appearance-none overflow-hidden bg-shades-light",
				"focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-medium focus-visible:ring-offset-1 motion-safe:transition-colors",
				className,
			)}
			{...remainingProps}
		>
			{item.type === "youtube" || item.type === "vimeo" ? (
				<VideoPlaceholder
					variant={item.type}
					className="h-full w-full 2xl:text-xl"
					id={item.videoId}
					alt={item.alt}
				/>
			) : (
				<Image
					src={item.alternativeSrc ?? item.src ?? ""}
					alt={item.alt}
					priority={item.priority}
					fill
					className="object-cover"
				/>
			)}

			{children}
		</button>
	);
}
